import { AssistantScenarioStatusEnum } from "../../enums";
import { IAssistantScenarioStatusPresentation } from "./types";

export const assistantScenarioStatusPresentation: Record<
  number,
  IAssistantScenarioStatusPresentation
> = {
  [AssistantScenarioStatusEnum.NOT_STARTED]: {
    label:
      AssistantScenarioStatusEnum.choices[
        AssistantScenarioStatusEnum.NOT_STARTED
      ],
    symbol: "○",
  },
  [AssistantScenarioStatusEnum.IN_PROGRESS]: {
    label:
      AssistantScenarioStatusEnum.choices[
        AssistantScenarioStatusEnum.IN_PROGRESS
      ],
    symbol: "●",
  },
  [AssistantScenarioStatusEnum.COMPLETED]: {
    label:
      AssistantScenarioStatusEnum.choices[
        AssistantScenarioStatusEnum.COMPLETED
      ],
    symbol: "✓",
  },
  [AssistantScenarioStatusEnum.SKIPPED]: {
    label:
      AssistantScenarioStatusEnum.choices[AssistantScenarioStatusEnum.SKIPPED],
    symbol: "↷",
  },
};

export const assistantScenarioLegend = [
  AssistantScenarioStatusEnum.COMPLETED,
  AssistantScenarioStatusEnum.SKIPPED,
  AssistantScenarioStatusEnum.IN_PROGRESS,
  AssistantScenarioStatusEnum.NOT_STARTED,
].map((status) => ({
  status,
  label: assistantScenarioStatusPresentation[status].label,
}));
